export class Perfil{
    public id:number;
    public nombre:string;
    constructor(){
        this.id = 0;
        this.nombre = "";
     }
}
